import { Route, Switch } from 'react-router';
import { contentsRoutes } from './constants';


const ContentsRoutes = () => {

  return (
		<Switch>
			{
				contentsRoutes.map((route, index) => {
					return (
						<Route
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />						
					)
				})
			}
		</Switch>
	);
}

export default ContentsRoutes;